<template>
    <v-form>
       <v-list two-line subheader>
           <v-subheader>Document Containers</v-subheader>
           <v-list-title
                   v-for="item in docs"
                   :key="item.name"
                   avatar>

               <v-list-title-icon>
                   <v-icon>fas fa-file-alt</v-icon>
               </v-list-title-icon>

               <v-list-title-content>
                   <v-list-title>
                        {{item.name}}
                   </v-list-title>
                   <v-list-title-sub-title>
                       {{item.required === true ? 'required  ' : ''}} {{item.expiredInterval}}
                   </v-list-title-sub-title>
               </v-list-title-content>

           </v-list-title>
       </v-list>
        <v-layout >
            <v-flex justify-end row>
                <v-fab-transition>
                    <v-btn  color="blue"
                            dark
                            bottom
                            right
                            @click="dialog = true"
                            fab>
                        <v-icon>add</v-icon>
                    </v-btn>
                </v-fab-transition>
            </v-flex>
        </v-layout>
        <v-dialog v-model="dialog" max-width="500px">
            <v-card>
                <v-card-title
                        class="headline grey lighten-2"
                        primary-title>
                    Add a new Document Container
                </v-card-title>
                <v-card-text  pa-4>
                    <docDefinition @stepper="docAdded" @closeStepper="dialog = false"></docDefinition>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-divider class="mt-1"></v-divider>

        <v-btn  color="primary"
                @click="stpper3Continue">
            Continue
        </v-btn>

        <v-btn text @click="close">
            Cancel
        </v-btn>
    </v-form>
</template>

<script>
    const docDefinition = ()=> import( './DocumentRuleDefine');

    export default {
        name: "documentRuleManager",
        components: {
            docDefinition
        },
        data(){
            return{
                docs: [],
                dialog: false
            }
        },
        methods: {
            getDocs(){
                this.docs = this.$store.getters.getDocumentRules;
            },
            docAdded(){
                this.dialog = false;
                this.getDocs();
            },
            stpper3Continue(){
                this.$emit('stepper', 4)
            },
            close(){
                this.$emit('closeStepper', false)
            }

        },
        mounted(){
           this.getDocs();
        }
    }
</script>

<style scoped>
    button:focus, button:active, button.active, button:focus:active {
        background-image: none;
        outline: none;
        -webkit-box-shadow: none;
        box-shadow: none;
    }
</style>